import React from 'react';
import './Turf.css';

const Turf = () => {
  // Points to /public/images/turf.jpg
const backgroundUrl = `${process.env.PUBLIC_URL}/IMG_4584.jpeg`;

  return (
    <section
      className="Turf"
      style={{ backgroundImage: `url(${backgroundUrl})` }}
    >
      <div className="Turf__overlay">
        <h1 className="Turf__title">
          Artificial Turf Installation
        </h1>
      </div>
    </section>
  );
};

export default Turf;
